import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { getVisibilityOfBackendErrorPopup } from '../../core/states/app/app.selector';
import { changeVisibilityOfBackendError } from '../../core/states/app/app.actions';

@UntilDestroy()
@Component({
  standalone: false,
  selector: 'ssc-error-popup',
  templateUrl: './error-popup.component.html',
  styleUrls: ['./error-popup.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorPopupComponent implements OnInit {
  public showBackendErrorPopup$: Observable<boolean>;

  constructor(private store: Store) {}

  public ngOnInit(): void {
    this.showBackendErrorPopup$ = this.store.select(getVisibilityOfBackendErrorPopup);
  }

  public closePopup(): void {
    this.store.dispatch(changeVisibilityOfBackendError({ showBackendErrorPopup: false }));
  }
}
